import React, { memo } from 'react';
import { Button, Spacer } from 'design-system';
import BottomPanel from 'design-system/BottomPanel';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation, useMainStackRoute } from 'utils/types/navigationV6';
import SecclDiscoverShortcuts from './SecclDiscoverShortcuts';
import { selectShowInvestIntro } from '../reducers/selectors';
import SetupInvestmentAccountButton from './SetupInvestmentAccountButton';
const DiscoverShortcutsSeccl = ({ scrollX, scrollYReadyMade, scrollYDoItYourself, secclHorizontalScrollViewRef, startInDoItYourself, hideSeeAllFunds, }) => {
    const route = useMainStackRoute();
    const navigation = useMainStackNavigation();
    const showSetupButton = useAppSelector(selectShowInvestIntro);
    const handleSeeAllFunds = React.useCallback(() => {
        if (route.params?.depositAndBuyFlowParams) {
            navigation.navigateDeprecated('InvestSearchStock', {
                depositAndBuyFlowParams: route.params.depositAndBuyFlowParams,
            });
            return;
        }
        navigation.navigateDeprecated('InvestSearchStock');
    }, [route.params]);
    return (<>
      <SecclDiscoverShortcuts scrollX={scrollX} scrollYReadyMade={scrollYReadyMade} scrollYDoItYourself={scrollYDoItYourself} secclHorizontalScrollViewRef={secclHorizontalScrollViewRef} startInDoItYourself={startInDoItYourself}/>
      {!hideSeeAllFunds &&
            (!showSetupButton ? (<Button floating title="See all funds" brandReversed onPress={handleSeeAllFunds}/>) : (<BottomPanel>
            <Button brandReversed title="See all funds" onPress={handleSeeAllFunds}/>
            <Spacer h={8}/>
            <SetupInvestmentAccountButton brand/>
          </BottomPanel>))}
    </>);
};
export default memo(DiscoverShortcutsSeccl);
